import type { ChainEnum } from '@dynamic-labs/sdk-api-core';
import { ExchangeKeyEnum } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../../client/core/getCore';
import { getDefaultClient } from '../../../../client/defaultClient';
import { createApiClient } from '../../../apiClient';
import type { Chain } from '../../../chain';
import type { KrakenAccount } from '../kraken.types';

export type GetKrakenAccountsParams = {
  /**
   * Optional chain filter
   */
  chainName?: Chain;
  /**
   * Optional network ID filter
   */
  networkId?: number;
};

/**
 * Gets the Kraken accounts (balances) for the authenticated user
 *
 * @param [params] GetKrakenAccountsParams - Optional filters for the accounts.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns Array of Kraken accounts with balances
 */
export const getKrakenAccounts = async (
  params?: GetKrakenAccountsParams,
  client = getDefaultClient()
): Promise<KrakenAccount[]> => {
  const core = getCore(client);
  const apiClient = createApiClient({ includeMfaToken: true }, client);

  const response = await apiClient.getUserAccounts({
    // eslint-disable-next-line custom-rules/ban-chain-enum
    chainName: params?.chainName as ChainEnum,
    environmentId: core.environmentId,
    exchangeKey: ExchangeKeyEnum.Kraken,
    networkId: params?.networkId,
  });

  return response;
};
